export default {
  title: 'Tu proveedor se encarga de este paso',
  description: {
    payments: 'Contacta a {{partner}} para configurar los pagos en línea.',
    go_live: 'Contacta a {{partner}} para activar tu restaurante.',
  },
  fallback_partner: 'tu proveedor',
};
